import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ModalComponent} from "../../../../../shared/components/index";
import {Log} from "ng2-logger";
import {Tool} from "@app/tool/model/tool.model";
import {TableConfig} from "@app/shared/util/table-config.utils";
import {ToolService} from "@services/tool.service";
import * as _ from "lodash";
import {ToastsManager} from "@app/shared/util/toastr.service";
import {TranslateService} from "@ngx-translate/core";


@Component({
    selector: 'app-tool-backup-modal',
    templateUrl: './tool-backup-modal.component.html',
    styleUrls: ['./tool-backup-modal.component.scss']
})
export class ToolBackupModalComponent {
    _logger = Log.create(ToolBackupModalComponent.name);

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() selectedTool: Tool;
    @Input() loading = false;

    @Output() saveBackups = new EventEmitter<any>();

    tableConfig: TableConfig = new TableConfig();
    _toolBackups: Tool[];
    selectedBackupTools: any[];

    constructor() {
    }

    open() {
        this.modal.open();
    }

    close() {
        this.modal.close();
        this._toolBackups = [];
        this.selectedBackupTools = [];
    }

    @Input()
    set toolBackups(backups) {
        this._toolBackups = backups;
        if (backups) {
            this.tableConfig.pager.count = backups.length;
            this.tableConfig.pager.selected = _.filter(backups, {selected: true}).length;

            this.selectedBackupTools = _.filter(backups, {selected: true}).map(item => item.id);
        }
    }

    get toolBackups() {
        return this._toolBackups;
    }

    onCheckedTools(backupTools: Tool[]) {
        this._logger.info('onCheckedTools:: Updating tool backups based on selections', backupTools);
        this.selectedBackupTools = backupTools;
    }

    onSave() {
        this.saveBackups.emit({
            selectedToolId: this.selectedTool.id,
            backupIds: this.selectedBackupTools,
        });
    }
}
